import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { FindInvoicesToExport, Invoice } from "contracts/Invoice";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["errorMessage"],
    softReset: [],
    load: ["progress"],
    reset: [],
  },
  {
    prefix: "EXPORT_INVOICES_",
  }
);

export interface ExportInvoicesState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
  progress: number
}

export interface ExportInvoicesRequestAction {
  query?: FindInvoicesToExport;
  onSuccess?: (data: Invoice[]) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ExportInvoicesState = {
  data: [],
  loading: false,
  errorMessage: null,
  progress: 0
};

const request = (state: ExportInvoicesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ExportInvoicesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ExportInvoicesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ExportInvoicesState) =>
  update(state, {
    loading: { $set: false },
  });

const load = (state: ExportInvoicesState, action: any) =>  
update(state, {
  progress: { $set: action.progress },
});

const reset = () => INITIAL_STATE;

export const exportInvoices = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.LOAD]: load,
  [Types.RESET]: reset,
});

export const ExportInvoicesTypes = Types;
export const ExportInvoicesActions = Creators;
